import { deleteAccount } from 'api/user';
import useAuthStore from 'store/auth';
import { Background, CommonWrapper } from 'styles/common/Layout';
import { Description, Form, Title } from 'styles/common/FormStyle';
import { ButtonOutline, ButtonSolid } from 'styles/common/ButtonStyle';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { BoxOutline } from 'styles/common/BoxStyle';

const WithdrawlAccount = () => {
  const authStore = useAuthStore();
  const navigate = useNavigate();
  const userInfo = authStore?.user;

  const withdraw = async (e) => {
    e.preventDefault();
    try {
      const res = await deleteAccount();
      if (res?.result) {
        alert('탈퇴가 완료되었습니다.');
        authStore.logout();
        navigate('/');
      } else {
        alert('탈퇴에 실패했습니다.');
      }
    } catch (error) {
      alert(error);
    }
  };

  const terms = [
    '탈퇴하실 경우 개인 정보 및 결제 내역을 포함한 모든 정보가 삭제되며, 그동안 사용하신 금액에 대한 페이백 혜택을 받으실 수 없습니다.',
    `탈퇴하시는 계정은 복구가 불가능합니다.`,
  ];

  return (
    <Background>
      <CommonWrapper>
        <Form onSubmit={withdraw}>
          <Title>회원탈퇴</Title>
          <Description textAlign="start" marginTop="0">
            {userInfo?.alias}님, 탈퇴 전 아래 사항을 확인해주세요.
          </Description>
          <BoxOutline margin="20px 0">
            {terms.map((term, index) => (
              <Description
                marginTop={index === 0 ? '0' : '12px'}
                textAlign="start"
              >
                ✓ {term}
              </Description>
            ))}
          </BoxOutline>
          <Row>
            <Col>
              <ButtonOutline type="button" onClick={() => navigate('/my')}>
                취소
              </ButtonOutline>
            </Col>
            <Col>
              <ButtonSolid type="submit" height="44px">
                동의 후 탈퇴
              </ButtonSolid>
            </Col>
          </Row>
        </Form>
      </CommonWrapper>
    </Background>
  );
};

export default WithdrawlAccount;
